import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import axios from "axios";
import ar from "./assets/lang/ar.json";
import en from "./assets/lang/en.json";

const getInitialLanguage = () => {
  const storedLang = localStorage.getItem("lang");
  if (storedLang) return storedLang;

  localStorage.setItem("lang", "en");
  return "en";
};

const initialLanguage = getInitialLanguage();
axios.defaults.headers.common["Accept-Language"] = initialLanguage;

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: en,
      ar: ar,
    },
    lng: initialLanguage,
    fallbackLng: "en",
    debug: true,
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "lang",
      caches: ["localStorage"],
    },
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
  });

export default i18n;
